
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/ovulation-calculator-fertility-calendar",
      function () {
        return require("private-next-pages/tools/ovulation-calculator-fertility-calendar/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/ovulation-calculator-fertility-calendar"])
      });
    }
  